import { Link } from 'react-router-dom'
import { listAppointments } from '../../api/appointments'
import { useFetch } from '../../hooks/useFetch'
import { cn, todayRange } from '@/lib/utils'
import { thClass, tdClass, tbodyHoverClass, badgeBaseClass } from '@/lib/tableStyles'
import type { AppointmentStatus } from '../../types/appointments'
import { STATUS_COLORS as APPT_STATUS_COLORS, STATUS_LABELS as APPT_STATUS_LABELS } from '../../types/appointments'
import { DashboardWidgetCard } from './DashboardWidgetCard'

export function TodaysAppointmentsWidget() {
  const today = todayRange()

  const { data: todayAppointments, loading } = useFetch(
    () => listAppointments({ date_from: today.from, date_to: today.to, limit: 50 }),
    [today.from],
  )

  return (
    <DashboardWidgetCard
      title={`Today's Appointments — ${new Date().toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long' })}`}
      viewAllHref="/appointments"
    >
      {loading ? (
        <div className="p-6 text-text-3 text-[0.875rem]">Loading…</div>
      ) : !todayAppointments || todayAppointments.length === 0 ? (
        <div className="px-5 py-6 text-text-3 text-[0.875rem]">
          No appointments scheduled for today.
        </div>
      ) : (
        <table className="w-full border-collapse text-[0.875rem]">
          <thead>
            <tr>
              <th className={thClass}>Time</th>
              <th className={thClass}>Patient</th>
              <th className={thClass}>Client</th>
              <th className={thClass}>Vet</th>
              <th className={thClass}>Status</th>
              <th className={cn(thClass, 'text-right')}></th>
            </tr>
          </thead>
          <tbody className={tbodyHoverClass}>
            {todayAppointments.map(a => {
              const { color, bg } = APPT_STATUS_COLORS[a.status as AppointmentStatus]
              return (
                <tr key={a.id}>
                  <td className={cn(tdClass, 'whitespace-nowrap')}>
                    {new Date(a.scheduled_at).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })}
                  </td>
                  <td className={cn(tdClass, 'font-medium')}>
                    {a.patient_name ? (
                      <Link to={`/patients/${a.patient_id}`} className="text-accent no-underline hover:underline">
                        {a.patient_name}
                      </Link>
                    ) : '—'}
                  </td>
                  <td className={cn(tdClass, 'text-text-2')}>
                    {a.client_name ? (
                      <Link to={`/clients/${a.client_id}`} className="text-text-2 no-underline hover:underline">
                        {a.client_name}
                      </Link>
                    ) : '—'}
                  </td>
                  <td className={cn(tdClass, 'text-text-2')}>{a.veterinarian_name ?? '—'}</td>
                  <td className={tdClass}>
                    <span
                      className={cn(badgeBaseClass, 'rounded-full')}
                      style={{ background: bg, color }}
                    >
                      {APPT_STATUS_LABELS[a.status as AppointmentStatus]}
                    </span>
                  </td>
                  <td className={cn(tdClass, 'text-right')}>
                    <Link to={`/appointments/${a.id}`} className="text-accent font-medium text-[0.8rem] no-underline hover:underline">
                      View →
                    </Link>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
    </DashboardWidgetCard>
  )
}
